import React from "react";
import "./WhatsAppCtaComponent.scss";

const WhatsAppCtaComponent = ({ phoneNumber = "36707177656", title = "Need More Information?", description = "Our travel concierge is ready to assist you with any questions about your journey or to help customize your trip." }) => {
  return (
    <div className="whatsapp-cta">
      <div className="whatsapp-cta-icon">
        <i className="fa-brands fa-whatsapp"></i>
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp">
        <i className="fa-brands fa-whatsapp"></i> WhatsApp Us
      </a>
    </div>
  );
};

export default WhatsAppCtaComponent;
